// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1736":"684aa123","6874":"4f349c1c"}[chunkId] + ".chunk.css";
};